import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PRODUCT_GROUPS } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export default function CategoriesShowcase() {
  return (
    <section id="categories" data-testid="categories-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="max-w-2xl">
          <Overline>Our Product Categories</Overline>
          <h2 className="font-serif-lux mt-5 text-4xl md:text-6xl leading-none tracking-tight">
            Everything a space needs, <span className="text-gold-gradient italic">under one roof.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-4 md:grid-cols-6 md:auto-rows-[minmax(0,1fr)]">
          {PRODUCT_GROUPS.map((g, i) => (
            <Reveal
              key={g.key}
              delay={i * 0.1}
              className={i === 0 ? "md:col-span-4 md:row-span-2" : "md:col-span-2"}
            >
              <Link
                to="/products"
                data-testid={`category-card-${g.key}`}
                className="group relative block h-full min-h-[300px] md:min-h-[280px] overflow-hidden border border-white/10"
              >
                <img src={g.image} alt={g.title} loading="lazy" className="img-lux absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/45 to-transparent" />
                <div className="absolute inset-0 border border-[#e7c15a]/0 group-hover:border-[#e7c15a]/50 transition-colors duration-500" />
                <div className="relative z-10 flex h-full flex-col justify-end p-7 md:p-8">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="font-serif-lux text-2xl md:text-3xl text-[#fafafa] tracking-tight">{g.title}</h3>
                      <p className="mt-3 text-sm text-[#b8b8b8] max-w-md">{g.blurb}</p>
                    </div>
                    <span className="shrink-0 h-11 w-11 grid place-items-center border border-[#e7c15a]/40 text-[#e7c15a] group-hover:bg-[#e7c15a] group-hover:text-[#050505] transition-colors duration-400">
                      <ArrowUpRight size={18} />
                    </span>
                  </div>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {g.items.slice(0, i === 0 ? 6 : 4).map((it) => (
                      <span key={it} className="text-[11px] uppercase tracking-wider text-[#c9c9c9] border border-white/10 px-3 py-1">{it}</span>
                    ))}
                    {g.items.length > (i === 0 ? 6 : 4) && (
                      <span className="text-[11px] uppercase tracking-wider text-[#e7c15a] px-3 py-1">+{g.items.length - (i === 0 ? 6 : 4)} more</span>
                    )}
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
